interface IProps {
  margin?: string | number;
  colour?: string;
  thickness?: string;
  style?: object;
  id?: string;
  className?: string;
}

const Separator = ({
  margin = '1em',
  colour = '#DDD',
  thickness = '2px',
  style,
  id,
  className,
}: IProps) => (
  <div id={id} className={`separator ${className}`} style={{ ...style }}>
    <style jsx>
      {`
        .separator {
          width: 100%;
          height: ${thickness};
          margin: ${margin} auto;
          background-color: ${colour};
        }
      `}
    </style>
  </div>
);

export default Separator;
